<template>
  <div class="b1">
    <div class="flex_between_nowrap">
      <span class="title_before side_title">出入记录</span>
    </div>
    <div style="padding: 0px 20px 0px 24px">
      <div
        class="flex_between_nowrap"
        style="margin-top: 20px; margin-bottom: 30px"
      >
        <div style="display: flex; align-items: center">
          <el-select
            v-model="params['type']"
            size="small"
            @change="tableSearch"
            style="width: 120px; margin-right: 20px"
          >
            <el-option label="全部" :value="null"></el-option>
            <el-option label="授权记录" value="in"></el-option>
            <el-option label="未授权记录" value="out"></el-option>
          </el-select>
          <el-input
            clearable
            placeholder="请输入资产名称或条码"
            size="small"
            v-model="params['search']"
            style="width: 200px; margin-right: 20px"
            @input="tableSearch"
          >
            <i
              slot="suffix"
              class="el-icon-search inputIcon"
              @click.stop="tableSearch"
            ></i>
          </el-input>
          <el-date-picker
            size="small"
            style="width: 260px"
            value-format="yyyy-MM-dd"
            v-model="pickerArr"
            type="daterange"
            @change="pickerChange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div style="display: flex">
          <el-button
            type="main"
            @click="receive('in')"
            style="
              min-width: 100px;
              width: auto;
              padding: 0px 6px;
              box-sizing: border-box;
            "
            >一键入库【{{ alarmCount.in || 0 }}】</el-button
          >
          <el-button
            type="main"
            @click="receive('out')"
            style="
              min-width: 100px;
              width: auto;
              padding: 0px 6px;
              box-sizing: border-box;
            "
            >一键出库【{{ alarmCount.out || 0 }}】</el-button
          >
          <el-button type="submit" @click="exportFile">记录导出</el-button>
        </div>
      </div>
      <x-table url="/pc/alarm/page" ref="xTable" :params="params">
        <el-table-column
          v-for="item in columnArr"
          :key="item.model"
          :label="item.label"
          :prop="item.model"
        >
          <template slot-scope="scope">
            <span
              v-if="item.model == 'ctype'"
              :style="
                scope.row[item.model] == 'in'
                  ? 'color:#67C23A'
                  : 'color:#F56C6C'
              "
              >{{ scope.row[item.model] == "in" ? "授权记录" : "未授权记录" }}</span
            >
            <span v-else>{{ scope.row[item.model] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              class="deleteColor"
              @click="
                $axiosDelete(
                  '/pc/alarm/del',
                  { alarmId: scope.row.alarmId },
                  tableSearch,
                  '',
                  true
                )
              "
              >删除</el-button
            >
          </template>
        </el-table-column>
      </x-table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pickerArr: [],
      alarmCount: {},
      params: { start: "", end: "", type: null },
      columnArr: [
        {
          label: "类型",
          model: "ctype",
        },
        {
          label: "资产编码",
          model: "assetCode",
        },
         
        {
          label: "资产名称",
          model: "assetName",
        },
        {
          label: "规格型号",
          model: "spec",
        },

        {
          label: "关联组织",
          model: "useDeptName",
        },
        {
          label: "关联人员",
          model: "usePersonName",
        },

        {
          label: "所在区域",
          model: "areaName",
        },

        {
          label: "操作时间",
          model: "alarmTime",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    receive(type) {
      this.$alertMsg.confirm(
        `即将进行一键${type == "in" ? "出库" : "入库"},是否继续？`,
        () => {
          this.$requestAxios(
            {
              url: "/pc/alarm/receive_all",
              data: { type },
              timeout: 120000,
            },
            (data) => {
              this.tableSearch();
              this.init();
              this.$message.success("操作成功！");
            }
          );
        }
      );
    },
    init() {
      this.$requestAxios(
        {
          url: "/pc/alarm/count",
          data: {},
        },
        (data) => {
          this.alarmCount = data.data || {};
          console.log(data);
        }
      );
    },
    exportFile() {
      this.$downloadAFile(
        { url: "/pc/alarm/explor", data: this.params },
        this.$getCurrentDate() + "记录导出"
      );
    },
    pickerChange(data) {
      if (data) {
        this.$set(this.params, "start", data[0]);
        this.$set(this.params, "end", data[1]);
      } else {
        this.$set(this.params, "end", "");
        this.$set(this.params, "start", "");
      }
      this.tableSearch();
    },
    tableSearch() {
      this.$refs.xTable.search();
    },
    add_area(row) {
      this.$createDialog(this, {
        dialogConfig: {
          title: JSON.stringify(row) == "{}" ? "区域新增" : "区域编辑",
          width: "360px",
        },
        namespace: "sys_add_area",
        whetherDestruction: true,

        assemblyConfig: {
          row: row,
          callBack: this.tableSearch,
        },
      });
    },
  },
};
</script>
<style scoped></style>
